var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPdf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "pdf",
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.5,
    height: 18.051,
    viewBox: "0 0 13.5 18.051",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vrstva_x0020_1_15_",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M102.123,0h6.035l5.115,5.331V15.7a2.348,2.348,0,0,1-2.345,2.35h-8.8a2.348,2.348,0,0,1-2.35-2.35V2.35A2.348,2.348,0,0,1,102.123,0Z",
    transform: "translate(-99.773 0)",
    fill: "#e5252a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22",
    transform: "translate(2.612 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M467.219,0V5.291h5.119Z",
    transform: "translate(-461.45)",
    fill: "#fff",
    fillRule: "evenodd",
    opacity: 0.302
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M214.278,449.256v-3.3h1.4a1.163,1.163,0,0,1,.83.289,1.1,1.1,0,0,1,0,1.534,1.163,1.163,0,0,1-.83.289h-.559v1.186Zm.843-1.9h.465a.416.416,0,0,0,.293-.09.348.348,0,0,0,0-.5.415.415,0,0,0-.293-.09h-.465Zm2.048,1.9v-3.3h1.168a2.039,2.039,0,0,1,.65.1,1.746,1.746,0,0,1,.55.293,1.3,1.3,0,0,1,.388.514,2.038,2.038,0,0,1,0,1.484,1.3,1.3,0,0,1-.388.514,1.746,1.746,0,0,1-.55.293,2.04,2.04,0,0,1-.65.1Zm.825-.717h.244a1.35,1.35,0,0,0,.365-.045,1.1,1.1,0,0,0,.311-.149.669.669,0,0,0,.226-.289,1.281,1.281,0,0,0,0-.9.669.669,0,0,0-.226-.289,1.1,1.1,0,0,0-.311-.149,1.351,1.351,0,0,0-.365-.045h-.244Zm2.494.717v-3.3h2.345v.717h-1.5v.528h1.2v.713h-1.2v1.34Z",
    transform: "translate(-214.278 -435.788)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.0b217b9e010f21683bec7ad830be1542.svg";
export { ForwardRef as ReactComponent };